import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { Box, Typography } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

type Props = {
  scheduledCarrier:
    | FreightMatching.schemas.OfferCargo["scheduledCarrier"]
    | null
    | undefined;
};

export const ScheduledCarrierInfo = ({ scheduledCarrier }: Props) => {
  if (!scheduledCarrier) {
    return null;
  }

  return (
    <Box maxWidth={"628px"}>
      <Typography variant="h6" fontWeight={700} mb={2}>
        配送予定車両
      </Typography>
      <BaseKeyValue keyLabel="実運送会社">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.name || "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="車両番号">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.vehicleNumber || "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="運転手名">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.contactName || scheduledCarrier.contactNameKana
            ? `${scheduledCarrier.contactName}${
                scheduledCarrier.contactNameKana
                  ? ` (${scheduledCarrier.contactNameKana})`
                  : ""
              }`
            : "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="電話番号">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.phoneNumber || "(未入力)"}
        </Typography>
      </BaseKeyValue>
    </Box>
  );
};
